import { Component, Input, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { BaseValueAccessorDirective } from '@se-po/shared-ui-form-directives'
import { SeFeTranslationsLoader } from 'se-fe-translations'

@Component({
  selector: 'se-po-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  hostDirectives: [BaseValueAccessorDirective],
  standalone: false,
})
export class EmailComponent implements OnInit {
  @Input() public hiddenLabel = false
  @Input() public seFeDataLabel?: string

  public loaded = false
  public ngControl = BaseValueAccessorDirective.ngControl(this) // get the forwarded control

  constructor(
    private seFeTranslationsLoader: SeFeTranslationsLoader)
  { }

  public get control(): AbstractControl {
    return this.ngControl?.control
  }

  public get form(): UntypedFormGroup | UntypedFormArray {
    return this.control?.parent
  }

  public ngOnInit(): void {
    this.initTranslations()
  }

  public initValidation(): void {
    this.control.addValidators([Validators.maxLength(100), this.seEmailValidator()])
    this.control.updateValueAndValidity()
  }

  public initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-email/assets/translations').then(() => {
      this.loaded = true
      this.initValidation()
    })
  }

  private seEmailValidator(): ValidatorFn {
    // eslint-disable-next-line
    const emailRegex = /^[a-zA-Z0-9!#$%&'*+\=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/

    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value
      if (!value || emailRegex.test(value)) {
        return null
      }
      return { invalidEmail: true }
    }
  }
}
